import SumsubWebSdk from "@sumsub/websdk-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiPaths } from "../../api/paths";
import { useAppContext } from "../../context/app-context";
import {
  BASIC_KYB_LEVEL,
  // BASIC_KYC_LEVEL,
  BASIC_KYT_LEVEL,
} from "../../resources/constants";
import { axiosInstance } from "../../services/axios-config/axios-config";

export default function ValidateSumsub() {
  const { t } = useTranslation(["home"]);
  const [token, setToken] = useState();
  const { keycloakProfile, user } = useAppContext();
  const getToken = async (levelName: string) => {
    const result = await axiosInstance.get(ApiPaths.sumsubToken, {
      params: {
        keycloakUserId: user?.username,
        levelName,
      },
    });
    return result.data?.token;
  };
  const createApplicant = async (levelName: string) => {
    const result = await axiosInstance.post(ApiPaths.sumsubToken, {
      keycloakUserId: user?.username,
      levelName,
    });
    return result.data;
  };

  useEffect(() => {
    const getData = async (levelName: string) => {
      if (!keycloakProfile?.applicant_id) {
        await createApplicant(levelName);
      }
      const tok = await getToken(levelName);
      setToken(tok);
    };
    if (user?.username || keycloakProfile?.walletAddress) {
      const level =
        user?.username?.toLowerCase() === "nautilus"
          ? BASIC_KYT_LEVEL
          : // : user?.attributes?.binary[0] === "0"
            // ? BASIC_KYC_LEVEL
            BASIC_KYB_LEVEL;
      getData(level ?? "");
    }
  }, [keycloakProfile, user]);

  return (
    <div>
      <div className="d-flex justify-content-center">
        <div style={{ maxWidth: "720px" }}>
          <h3 className="text-center font-20 mb-3">
            {t("sumsub.message.introduction", { ns: "home" })}
          </h3>
          <h3 className="text-center font-20">
            {t("sumsub.message.verification", { ns: "home" })}
          </h3>
        </div>
      </div>

      {token && keycloakProfile && (
        <SumsubWebSdk
          accessToken={token}
          expirationHandler={getToken}
          config={{
            email: keycloakProfile?.email,
          }}
        />
      )}
    </div>
  );
}
